import React, {FC} from 'react';
import {SxProps, Typography} from '@mui/material';
import {TypographyVariant} from "@mui/material/styles";
import {DateTime} from "luxon";

const DATE_FORMAT: Intl.DateTimeFormatOptions = {day: '2-digit', month: '2-digit', year: 'numeric'};

interface FormattedDateProps {
 sx?: SxProps,
 variant?: TypographyVariant
 date: DateTime
}

 const FormattedDate: FC<FormattedDateProps> = ({sx, variant, date}) => (
  <Typography
    sx={sx}
    component="span"
    variant={variant}
  >
    {date ? date.toLocaleString(DATE_FORMAT) : "n.a."}
  </Typography>
);

export default FormattedDate;